// React-Screen CCardPaymentMode ("Bankomat-/Kreditkartenzahlung") -
// Strangler Phase 5, Klasse B. Runbook: tools/REACT-STRANGLER.md.
// Ersetzt die ESM-Huelle cardpaymentmode.js (aus
// lib/scripts/pos/components/CMP_CCardPaymentMode.js).
// Legacy-DOM-Fixture: tests/react-fixtures/CCardPaymentMode.html, gezogen
// aus tests/visual-baseline/28-overlay-bankomat.html.
//
// Der Screen begleitet eine ZVT-Transaktion: CPaymentProcessor zeichnet ihn
// und stoesst danach makeDebitTransaction/makeCreditTransaction an; alle
// weiteren Schritte kommen als Rueckrufe vom Terminal (POS.Bankomat) -
// onDebitCardTransaction, onCreditCardTransaction, onCancelTransaction,
// onLowLevelError, onRetryTransaction, onBalance, manualCardNumber.
//
// ZUSTANDSAUTOMAT statt umgehaengter Handler: Legacy tauscht zur Laufzeit
// die properties.events der beiden XML-Knoepfe aus (cancel ->
// creditCardCancellation -> getCardNumber -> getCardDate -> sendCardData)
// und ruft reStyle/reAttribute/reValue. Fuer Elemente, die REACT rendert,
// gehoert das in den Zustand (Regel im Runbook, zuerst bei
// CTransactionShowMode): bridge.state.okAction/backAction entscheiden, WAS
// der Knopf ausloest, bridge.state.okVis/backVis, OB er sichtbar ist. Der
// per makeOkButtons erzeugte "Bon drucken"-Knopf bleibt dagegen eine echte
// Legacy-Komponente mit unveraendertem Code.
import { defineReactScreen } from '../bridge.js';
import { CPushButton } from '../../components/pushbutton.js';
import { KnopfAusHandle } from '../widgets.jsx';

// Legacy-CCaption: innerHTML = value UND class = "CCaption <addclass> <value>".
function Caption({ bridge, path, addclass, value, style }) {
  const cls = 'CCaption' + (addclass ? ' ' + addclass : '') + ' ' + value;
  return <p {...bridge.el(path, 'CCaption')} className={cls} style={style}
            dangerouslySetInnerHTML={{ __html: value }} />;
}

function CardPaymentModeScreen({ bridge }) {
  const st = bridge.state;

  // Legacy-Handler-Kette, hier ueber den Zustand ausgewaehlt.
  const okHandler = () => {
    switch (st.okAction) {
      case 'creditSuccess': return bridge.creditCardSuccess();
      case 'cardNumber': return bridge.getCardNumber();
      case 'cardDate': return bridge.getCardDate(null, [bridge.id, st.okParam1]);
      case 'sendCardData': return bridge.sendCardData();
      default: return bridge.cancel();
    }
  };
  const backHandler = () => {
    if (st.backAction == 'creditCancellation') return bridge.creditCardCancellation();
    return bridge.cancel();
  };

  const okAttributes = { onMousedown_parameter_0: bridge.id };
  if (st.okParam1) okAttributes.onMousedown_parameter_1 = st.okParam1;

  const okButton = bridge.widget('7', 'CPushButton', {
    events: { onMousedown: okHandler, onMouseout: true, onMouseup: true },
    attributes: okAttributes,
    proto: CPushButton.prototype,
  });
  const backButton = bridge.widget('8', 'CPushButton', {
    events: { onMousedown: backHandler, onMouseout: true, onMouseup: true },
    attributes: { onMousedown_parameter_0: bridge.id },
    proto: CPushButton.prototype,
  });

  return (
    <>
      {/* wholeOverlay */}
      <div {...bridge.el('0', 'CFrame')} className="CFrame wholeoverlay" style={{ position: 'absolute' }}></div>
      {/* overlay */}
      <div {...bridge.el('1', 'CFrame')} className="CFrame overlay" style={{ position: 'absolute' }}></div>
      {/* titleBack */}
      <div {...bridge.el('2', 'CFrame')} className="CFrame titleback" style={{ position: 'absolute' }}></div>
      {/* titleText */}
      <Caption bridge={bridge} path="3" addclass="titletext" value={st.title} />
      {/* contentText */}
      <Caption bridge={bridge} path="4" addclass="contenttext" value={st.content}
               style={{ fontSize: '1.7vh' }} />
      {/* priceText */}
      <Caption bridge={bridge} path="5" addclass="pricetext" value=" " />
      {/* unitsText */}
      <Caption bridge={bridge} path="6" addclass="unitstext" value={st.units}
               style={{ fontSize: '1.7vh', left: '1vw', width: '33vw' }} />
      {/* okButton */}
      <div {...okButton} className="CPushButton okbutton"
           style={{ left: '24vw', visibility: st.okVis }}>
        <Caption bridge={bridge} path="7:0" addclass="" value=" " />
      </div>
      {/* backButton */}
      <div {...backButton} className="CPushButton backbutton"
           style={st.backVis ? { visibility: st.backVis } : undefined}>
        <p {...bridge.el('8:0', 'CCaption')} className="CCaption undefined"></p>
      </div>
      {/* Kind 9 ("Bon drucken"): das DOM baut React, die WERTE bleiben im
          Handle, das makeOkButtons() unveraendert befuellt. Der Knopf
          erscheint erst, wenn KEIN Terminal angeschlossen ist - deshalb
          steht seine Sichtbarkeit im Zustand und nicht fest in der JSX. */}
      {(bridge.state.okKnoepfe || []).map((gez, i) =>
        gez ? <KnopfAusHandle key={'ok' + i} bridge={bridge} pfad={String(9 + i)} /> : null)}
    </>
  );
}

export const CCardPaymentMode = defineReactScreen({
  className: 'CCardPaymentMode',
  addclass: 'CCardPaymentMode CashWindow',
  htmlType: 'div',
  Screen: CardPaymentModeScreen,
  initialState: {
    title: '', content: '', units: '',
    okVis: 'hidden', backVis: null, okAction: 'cancel', backAction: 'cancel', okParam1: null, okKnoepfe: []},
  prepare(bridge) {
    bridge.voucher = null;

    bridge.Main = POS.sessions.getSessionComponent();


    var text;
    switch (bridge.cardType) {
      case 'BC':
        text = bridge.t('LABELS', 'CARD_PAYMENT_BC_MODE');
        break;
      case 'CC':
        text = bridge.t('LABELS', 'CARD_PAYMENT_CC_MODE');
        break;
    }
    bridge.state.title = text;

    if (POS.EnvProperties.BANKOMATTERMINAL == 'YES') {
      bridge.state.content = bridge.t('LABELS', 'CARD_PAYMENT_MODE_TEXT');
      // Ohne Terminal bleibt der Abbrechen-Knopf sichtbar (kein style).
      bridge.state.backVis = 'hidden';
    } else
      bridge.state.content = bridge.t('LABELS', 'CARD_PAYMENT_MODE_NO_BKT_TEXT');

    bridge.Main.components.payment.setEnabled(false);
    bridge.Main.components.payment2.setEnabled(false);
    bridge.Main.components.bonedit.setEnabled(false);
    bridge.Main.components.prodSelect.setEnabled(false);
    bridge.Main.components.leftPad.setEnabled(false);
    bridge.Main.components.bonfnc.setEnabled(false);
    bridge.Main.components.numPad.setEnabled(false);

    bridge.initDisplay();
  },
  methods: {
    // "Bon drucken" (Legacy-Kind-Knopf) ohne Terminal.
    paymentOk(bridge, component, parameters) {
      var printMode = parameters[1];

      var voucher = new Array('DBId', 'voucherNo');
      voucher.DBId = bridge.paymentType;

      bridge.Main.BonManager.printMode = printMode;
      bridge.Main.BonManager.payCallback(bridge.Main.BonManager, voucher, bridge.amount, 0, bridge.openAmount);

      bridge.doCancel(bridge.t('DISPLAY', 'PAID'));
    },
    makeCreditTransaction(bridge, bonId) {
      POS.bankomatActive = true;
      POS.Bankomat.buyCredit(bridge.amount, bonId, bridge);
    },
    makeDebitTransaction(bridge, bonId) {
      POS.bankomatActive = true;
      if (POS.Bankomat)
        POS.Bankomat.buyDebit(bridge.amount, bonId, bridge);
    },
    makeNegTransaction(bridge, bonId) {
      // Ohne Zahlungsbeleg gibt es nichts zu stornieren - frueher Absturz
      // ("reading 'voucherNo'") und ein haengender Kartenschirm (Breitenfurt
      // 12.10.2026). addEntryPAY laesst Bankomat ohne offenen Betrag gar
      // nicht mehr bis hierher; das hier ist nur das Netz darunter.
      if (!bridge.voucher) {
        log.add(2, 'Warning', 'Bankomat', 'Storno ohne Zahlungsbeleg - abgebrochen');
        bridge.doCancel();
        return;
      }
      POS.bankomatActive = true;
      if (POS.Bankomat)
        POS.Bankomat.reversal(Math.abs(bridge.amount), bridge.voucher.voucherNo, bridge);
    },
    // --- Rueckrufe des Terminals -------------------------------------------
    onLowLevelError(bridge, me, message) {
      bridge.update({ units: message, backVis: 'visible' });
    },
    onCancelTransaction(bridge, me, message) {
      bridge.sendDisplayMessage(bridge.t('DISPLAY', 'BANKOMAT_TRANSACTION_BROKEN'));
      bridge.update({
        units: message, okVis: 'hidden', backVis: 'visible', backAction: 'cancel',
      });
    },
    onDebitCardTransaction(bridge, me, message, voucher) {
      bridge.sendDisplayMessage(message);

      bridge.update({ units: voucher.resultText, okVis: 'visible' });

      bridge.Main.BonManager.printMode = 'bill';
      bridge.Main.BonManager.payCallback(bridge.Main.BonManager, voucher, bridge.amount, 0, bridge.openAmount);
      bridge.doCancel();
    },
    onCreditCardTransaction(bridge, me, message, voucher) {
      bridge.sendDisplayMessage(message);

      bridge.voucher = voucher;
      if (voucher.signature) {
        bridge.update({
          content: bridge.t('LABELS', 'CONF_CARD_SIGNATURE'),
          units: voucher.resultText,
          backAction: 'creditCancellation', backVis: 'visible',
          okAction: 'creditSuccess', okVis: 'visible',
        });
      } else {
        bridge.Main.BonManager.printMode = 'bill';
        bridge.Main.BonManager.payCallback(bridge.Main.BonManager, bridge.voucher, bridge.amount, 0, bridge.openAmount);
        bridge.voucher = null;
        bridge.doCancel();
      }
    },
    creditCardSuccess(bridge) {
      bridge.Main.BonManager.printMode = 'bill';
      bridge.Main.BonManager.payCallback(bridge.Main.BonManager, bridge.voucher, bridge.amount, 0, bridge.openAmount);
      bridge.voucher = null;

      bridge.doCancel();
    },
    creditCardCancellation(bridge) {
      if (bridge.voucher == null)
        return;

      POS.timeout.register('hideButtons', bridge.hideButtons, bridge, 1, 1);

      POS.Bankomat.cancellation(Math.abs(bridge.amount), bridge.voucher.voucherNo, bridge);
      bridge.voucher = null;
    },
    hideButtons(bridge) {
      bridge.update({ backVis: 'hidden', okVis: 'hidden' });
    },
    onTransactionShortage(bridge, number) {
      var text = bridge.t('MESSAGES', 'BANKOMAT_OUT_OF_MEMORY_1');
      text += ' ' + number + ' ';
      text += bridge.t('MESSAGES', 'BANKOMAT_OUT_OF_MEMORY_2');
      POS.message.show(text, 'info', 'OK');
    },
    onRetryTransaction(bridge, me, message, bankomatCallback, callbackParams) {
      bridge.sendDisplayMessage(message);

      bridge.bankomatCallback = bankomatCallback;
      bridge.bankomatCallbackParams = callbackParams;
      window.text = bridge.t('MESSAGES', 'CONF_BANKOMAT_ANOTHER_TRY');
      POS.message.show(message + '<br><br>' + text, 'question', 'YESNO', bridge, bridge.doOnRetryTransaction);
    },
    doOnRetryTransaction(bridge, me, result) {
      if (result != 'YES') {
        bridge.doCancel();
        return;
      }

      POS.timeout.register('bankomatCallback', bridge.bankomatCallback,
        bridge.bankomatCallbackParams, 1, 1);
    },
    onBalance(bridge, me, message, voucher) {
      bridge.sendDisplayMessage(message);

      bridge.update({ units: voucher.resultText, okVis: 'visible' });
    },
    // --- Manuelle Karteneingabe --------------------------------------------
    manualCardNumber(bridge) {
      bridge.update({
        okVis: 'visible', okAction: 'cardNumber', backVis: 'visible',
        content: bridge.t('LABELS', 'PLEASE_ENTER_CARD_NUMBER'),
      });

      bridge.Main.components.numPad.setEnabled(true);
    },
    getCardNumber(bridge) {
      bridge.cardNr = bridge.Main.vacuumInfoValue(bridge.Main);

      bridge.update({
        units: bridge.t('LABELS', 'CARD_NUMBER') + ' ' + bridge.cardNr +
          '<br><br>' + bridge.t('LABELS', 'CARD_DATE') + ' ',
        okAction: 'cardDate', okParam1: 'MM',
        content: bridge.t('LABELS', 'PLEASE_ENTER_EXPIRATION_MONTH'),
      });
    },
    getCardDate(bridge, component, parameters) {
      var units = bridge.state.units;

      if (parameters[1] == 'MM') {
        bridge.month = expandInteger(bridge.Main.vacuumInfoValue(bridge.Main), 2);
        units += bridge.month + '/';
      } else {
        bridge.year = bridge.Main.vacuumInfoValue(bridge.Main);
        units += bridge.year;
      }

      if (parameters[1] == 'MM') {
        bridge.update({
          units: units,
          content: bridge.t('LABELS', 'PLEASE_ENTER_EXPIRATION_YEAR'),
          okAction: 'cardDate', okParam1: 'YY',
        });
      } else {
        bridge.update({
          units: units,
          okAction: 'sendCardData',
          content: bridge.t('LABELS', 'CONFIRM_CARD_DATA'),
        });
      }
    },
    sendCardData(bridge) {
      var dateFormatted = bridge.year + expandInteger(bridge.month, 2);

      POS.Bankomat.redemandCardData(bridge.cardNr, dateFormatted, bridge);
    },
    // --- Abbruch/Ende ------------------------------------------------------
    cancel(bridge) {
      bridge.sendDisplayMessage('');
      bridge.doCancel();
    },
    doCancel(bridge, message) {
      if (message)
        bridge.sendDisplayMessage(message);

      bridge.Main.components.bonfnc.setEnabled(true);
      bridge.Main.components.numPad.setEnabled(true);
      bridge.Main.components.payment.setEnabled(true);
      bridge.Main.components.payment2.setEnabled(true);
      bridge.Main.components.bonedit.setEnabled(true);
      bridge.Main.components.prodSelect.setEnabled(true);
      bridge.Main.components.leftPad.setEnabled(true);

      POS.bankomatActive = false;

      log.add(4, 'Info', 'End bankomat payment', '');


      bridge.removeMe();
    },
    sendDisplayMessage(bridge, message) {
      var expr = /\n/;
      var messages = message.split(expr);
      Display.addLine();
      Display.addElement(messages[0], 0, 0, 0, 19);
      Display.addLine();
      if (messages.length > 1)
        Display.addElement(messages[1], 19, 1, 0, 19);
      else
        Display.addElement('', 9, 2, 0, 19);
      Display.out();
    },
    initDisplay(bridge) {
      Display.addLine();
      Display.addElement(bridge.t('DISPLAY', 'BANKOMAT_ACTIVE'), 0, 0, 0, 19);
      Display.addLine();
      Display.addElement(bridge.t('LABELS', 'OPEN') + ':', 0, 0, 0, 19);
      Display.addElement(float2StringD2(bridge.amount) + ' &euro;', 19, 1, 0, 19);
      Display.out();
    },
    // Aufrufer: CPaymentProcessor, wenn KEIN Terminal angeschlossen ist.
    makeOkButtons(bridge) {
      bridge.okButtons = new Array();

      for (var i = 0; i < 1; i++) {
        // Handle an FESTEM Pfad 9 statt addChild - das DOM baut die JSX.
        bridge.okButtons[i] = bridge.widgetHandle(String(9 + i));
        bridge.okButtons[i].properties.attributes.onMousedown_parameter_0 = bridge.id;
        bridge.okButtons[i].properties.styles.position = 'absolute';
        bridge.okButtons[i].properties.styles.top = '80%';
        bridge.okButtons[i].properties.styles.width = '8vw';
        bridge.okButtons[i].properties.styles.height = '5vh';
        bridge.okButtons[i].properties.styles.backgroundColor = '#BBF3BB';
        bridge.okButtons[i].properties.styles.borderColor = '#77CC77';
      }

      bridge.okButtons[0].properties.styles.left = '2.5vw';
      bridge.okButtons[0].properties.caption.value = bridge.t('BUTTONS', 'PRINT_BON');
      bridge.okButtons[0].properties.attributes.onMousedown_parameter_1 = 'bill';
      bridge.okButtons[0].properties.events.onMousedown = (component, parameters) =>
        bridge.paymentOk(component, parameters);
      bridge.update({ okKnoepfe: [true] });   // statt draw() - React zeichnet
    },
  },
});
